import styled from 'styled-components';
import React, { FunctionComponent } from 'react';

const Content: FunctionComponent<{ className?: string }> = ({ className }) => (
    <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
        <path
            d='M10 2.5C5.86426 2.5 2.5 5.86426 2.5 10C2.5 14.1357 5.86426 17.5 10 17.5C14.1357 17.5 17.5 14.1357 17.5 10C17.5 5.86426 14.1357 2.5 10 2.5ZM10 3.75C13.4595 3.75 16.25 6.54053 16.25 10C16.25 13.4595 13.4595 16.25 10 16.25C6.54053 16.25 3.75 13.4595 3.75 10C3.75 6.54053 6.54053 3.75 10 3.75ZM9.375 6.25V11.25H10.625V6.25H9.375ZM9.375 12.5V13.75H10.625V12.5H9.375Z'
            fill='#DE1C22'
        />
    </svg>
);

const ExclamationCircleSolid = styled(Content)`
    width: 20px;
    height: 20px;
`;

export default ExclamationCircleSolid;
